import React, { useState } from "react";
import styles from "./AbsentDetails.module.css";
import HeadingAndIcon from "../../components/HeadingAndIcon/HeadingAndIcon";
import ToClose from "../../components/ToClose/ToClose";
import HeadingAndDropDown from "../../components/HeadingAndDropDown/HeadingAndDropDown";
import SaveAndCancel from "../../components/SaveAndCancel/SaveAndCancel";
import { BiLogOut } from "react-icons/bi";
import { useDispatch } from "react-redux";
import { closeModal } from "../../redux/slices/modalSlice";

const AbsentDetails = () => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    type: "",
    notes: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCancel = () => {
    setFormData({
      type: "",
      notes: "",
    });
  };

  const handleSave = () => {
    console.log("Absent marked:", formData);
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.headerBox}>
        <HeadingAndIcon
          icon={<BiLogOut size={22} />}
          heading="Mark as Absent"
        />
        <ToClose onClose={() => dispatch(closeModal())} />
      </div>
      <div className={styles.body}>
        <div className={styles.formContent}>
          <HeadingAndDropDown
            label="Type"
            name="type"
            value={formData.type}
            onChange={handleChange}
            options={[
              { value: "Darshan", label: "Darshan" },
              { value: "Doctor", label: "Doctor" },
              { value: "Family", label: "Family Emergency" },
            ]}
            required
          />

          <div className={styles.inputBlock}>
            <label htmlFor="notes" className={styles.inputLabel}>
              Notes
            </label>
            <textarea
              id="notes"
              name="notes"
              placeholder="Describe the reason ...."
              value={formData.notes}
              onChange={handleChange}
              className={styles.textarea}
            />
          </div>
          <div className={styles.SaveAndCancel}>
            <SaveAndCancel
              onCancel={handleCancel}
              onSave={handleSave}
              cancelLabel="Cancel"
              saveLabel="Mark as absent"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AbsentDetails;
